import React, { useState } from "react";
import { useEffect } from 'react';
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import {
  productsList,
  resetProductList,
  updateProduct,
} from "../../reducers/commonReducer";


import { getCategoriesFrontEnd } from "../../reducers/frontEndReducer";

const schema = yup.object().shape({
  name: yup.string().required("Name is required."),
  description: yup.string().required("Description is required."),
  mrp: yup.string().required("MRP is required."),
  sale: yup.string(),
  timePeriod: yup.string().required("Time period is required."),

  status: yup.boolean().required("Status is required."),
  benefits: yup.array().of(yup.string().required("Benefit is required.")),
});

function UpdateProduct(props) {

  const {
    pname,
    pdescription,
    pmrp,
    psale,
    ptax_class,
    ptimePeriod,
    id,
    pstatus,
    pcategory,
    pbenefits,
  } = props;





  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const { getTaxgstsData } = useSelector(
    (state) => state.commonReducer
  );

  const { getCatsFrontEndData } = useSelector((state) => state.frontEndReducer);

  const [benefits, setBenefits] = useState(pbenefits);

  const handleBenefitChange = (index, e) => {
    const newBenefits = [...benefits];
    newBenefits[index] = e.target.value;
    setBenefits(newBenefits);
  };

  const handleAddBenefit = () => {
    setBenefits([...benefits, ""]);
  };

  const handleRemoveBenefit = (index) => {
    const newBenefits = [...benefits];
    newBenefits.splice(index, 1);
    setBenefits(newBenefits);
  };

  const generateSlug = (name) =>
    name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");


  useEffect(() => {
    dispatch(getCategoriesFrontEnd());
  }, [dispatch]);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        <i className="bi bi-pencil-square"></i>
      </Button>
      <Modal className="modal-xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Plans</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize={true}
            validationSchema={schema}
            initialValues={{
              name: pname,
              description: pdescription,
              mrp: pmrp,
              sale: psale,
              timePeriod: ptimePeriod,
              category: pcategory,
              tax_class: ptax_class?.id,
              status: pstatus,
              benefits: pbenefits,
              id,
            }}
            onSubmit={async (values) => {
              values.benefits = benefits;
              await dispatch(updateProduct(values));
              await dispatch(resetProductList());
              await dispatch(productsList());
              handleClose();
            }}
          >
            {({
              handleSubmit,
              handleChange,
              values,
              setFieldValue,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={values.name}
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue("slug", generateSlug(e.target.value));
                        }}
                        isInvalid={!!errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={5}>
                    <Form.Group>
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        isInvalid={!!errors.description}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.description}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>MRP</Form.Label>
                      <Form.Control
                        type="number"
                        name="mrp"
                        value={values.mrp}
                        onChange={handleChange}
                        isInvalid={!!errors.mrp}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.mrp}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Sale Price</Form.Label>
                      <Form.Control
                        type="number"
                        name="sale"
                        value={values.sale}
                        onChange={handleChange}
                        isInvalid={!!errors.sale}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.sale}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">



                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Service</Form.Label>
                      <Form.Control
                        as="select"
                        name="category"
                        value={values?.category}
                        onChange={handleChange}
                        isInvalid={!!errors.category}
                      >
                        <option value="">Select Service</option>
                        {getCatsFrontEndData?.map((data) => (
                          <option key={data?.id} value={data?.id}>
                            {data?.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.category}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>


                  <Col md={3}>
                    <Form.Label>Tax Class</Form.Label>
                    <Form.Control
                      as="select"
                      name="tax_class"
                      onChange={handleChange}
                      value={values.tax_class}
                      isInvalid={!!errors.tax_class}
                    >
                      {getTaxgstsData?.list?.map((data) => (
                        <option value={data?.id} key={data?.id}>
                          {data?.name}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.tax_class}
                    </Form.Control.Feedback>
                  </Col>

             

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Time Period (Days)</Form.Label>
                      <Form.Control
                        type="number"
                        name="timePeriod"
                        value={values.timePeriod}
                        onChange={handleChange}
                        isInvalid={!!errors.timePeriod}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.timePeriod}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6} sm={12}>
                              <Form.Label>Status</Form.Label>
                              <Form.Control
                                as="select"
                                controlId="validationFormik03"
                                onChange={async (e) => {
                                  setFieldValue("status", e.target.value);
                                }}
                                name="status"
                                className="form-control"
                                value={values.status}
                                isInvalid={!!errors.status}
                              >
                                <option value="">Select Status</option>
                                <option value={true}>Active</option>
                                <option value={false}>InActive</option>
                              </Form.Control>
                            </Col>
                </Row>

                <Row className="mt-3">
                  {benefits?.map((benefit, index) => (
                    <Col md={12} key={index}>
                      <Form.Group>
                        <Form.Label>Benefit #{index + 1}</Form.Label>
                        <Form.Control
                          type="text"
                          name={`benefit${index}`}
                          value={benefit}
                          onChange={(e) => handleBenefitChange(index, e)}
                          isInvalid={!!errors.benefits && !!errors.benefits[index]}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.benefits && errors.benefits[index]}
                        </Form.Control.Feedback>
                        {index > 0 && (
                          <Button
                            variant="danger"
                            size="sm"
                            className="mt-2 float-end"
                            onClick={() => handleRemoveBenefit(index)}
                          >
                            Remove Benefit
                          </Button>
                        )}
                      </Form.Group>
                    </Col>
                  ))}
                  <Col md={12} className="mt-3">
                    <Button variant="primary" onClick={handleAddBenefit}>
                      Add Benefit
                    </Button>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Button variant="success" type="submit">
                      Update Plans
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UpdateProduct;
